import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {NavItemComponent} from './nav-item.component';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [NavItemComponent],
  imports: [CommonModule, MatIconModule, RouterModule],
  exports: [NavItemComponent],
})
export class NavItemModule {}
